import ModelFactory from 'business/models/ModelFactory';
import { DropsClient, IScoresOfWellDropsDTO } from 'business/models/Models';
import BaseService from './BaseService';

export default class DropService extends BaseService {
  async getDropScoresByWellDropIds(
    dropIds: number[],
  ): Promise<{ [key: string]: IScoresOfWellDropsDTO[] }> {
    const client: DropsClient = ModelFactory(DropsClient);
    return (await client.getDropScoresByDropIds(dropIds))
      .map((x) => x.toJSON())
      .groupByMultipleKeys('dropId', 'scoreBatchId');
  }
}
